export default __webpack_public_path__ + "static/ecommerce_back-7a62f53b69e24e61756c99010819c0d9.webp";